// @ts-ignore
import window from "global/window";

export const textColors = {
  primary: "#FFCF00",
  secondary: "#45B36B",
  black: "#000000",
  dark: "#141416",
  inDark: "#303437",
  inkDark: "#141416",
  blueGray: "#23262F",
  sceptreBlue: "#353945",
  yourShadow: "#777E91",
  yourLighter: "#8A92A6",
  brotherBlue: "#B1B5C3",
  harrison: "#979C9E",
  purpleCrystal: "#E6E8EC",
  whiteSmoke: "#F4F5F6",
  brilliance: "#FCFCFD",
  coronation: "#ECECEC",
  hat: "#F3F5F7",
  yukon: "#F7F7F7",
  white: "#FFFFFF",
  blackFire: "#7B5900",
  vermin: "#936F00",
  kenyan: "#B68D00",
  palomino: "#DBAD00",
  fluorescent: "#FFCF00",
  sunny: "#FFDF3F",
  friedEgg: "#FFE866",
  daisy: "#FFF199",
  lemon: "#FFF9CB",
  spruce: "#075F36",
  billiard: "#0D5442",
  jade: "#166649",
  lucky: "#218054",
  eucalyptus: "#329961",
  deepMidori: "#32DA82",
  success: "#23C16B",
  midori: "#44B26B",
  serengeti: "#70D088",
  pearl: "#91E79E",
  spring: "#BAF7BC",
  aero: "#B1E2CC",
  transparentGreen: "#DDFADC",
  transparentGreen05: "#ECFBEC",
  impression: "#111E7A",
  north: "#1E3094",
  night: "#3047B7",
  royal: "#4663DB",
  adamantine: "#48A7F8",
  deep: "#6084FF",
  deepBlue: "#6CBAFC",
  kitten: "#87A5FF",
  cornflower: "#7D64F2",
  indigo: "#937EFF",
  pastel: "#A0B8FF",
  periwinkle: "#BFD1FF",
  anakiwa: "#8BEBFF",
  sinter: "#DFEAFF",
  lavender: "#E5E1FD",
  obscure: "#771B04",
  brownRed: "#912A09",
  martian: "#B4400F",
  tomato: "#D65A14",
  orange: "#FA791D",
  ginger: "#FBA454",
  nouveau: "#FDBF76",
  champagne: "#FED9A4",
  bonnie: "#FDEED1",
  velvet: "#700749",
  orchid: "#870C4D",
  plum: "#A61453",
  rose: "#C91D57",
  red: "#FF0000",
  pop: "#E92857",
  pepper: "#F05B71",
  skyLighter: "#F2F4F5",
  pepperLight: "#FD7773",
  peach: "#F87C84",
  fond: "#FCADA9",
  pale: "#FCD9D3",
  oregano: "#ED5278",
  amnesia: "rgba(7,7,7,0.05)",
  midnight: "rgba(0,0,0,0.25)",
  paleSky: "#6F767E",
  slate: "#777E91",
  sadet: "#B1B5C3",
  callDark: "#0d0d0d",
  cardDark: "#0f0f10",
  panache: "#ECFCE5",
  pinkTheory: "#FFE5E5",
  ladylike: "#FFC1C1",
  flirtySalmon: "#FF6D6D",
  soulfulBlue: "#777E90",
  greyWhale: "#edeef0",
  pumpkin: "#FA791D",
};
export const bgColors = {
  transparent: "transparent",
  primary: "#FFCF00",
  secondary: "#45B36B",
  success: "#23C16B",
  black: "#000000",
  dark: "#141416",
  inDark: "#303437",
  inkDark: "#141416",
  blueGray: "#23262F",
  mineShaft: "#323232",
  sceptreBlue: "#353945",
  grayDark: "#272B30",
  yourShadow: "#777E91",
  yourLighter: "#8A92A6",
  brotherBlue: "#B1B5C3",
  harrison: "#979C9E",
  purpleCrystal: "#E6E8EC",
  whiteSmoke: "#F4F5F6",
  skyLighter: "#F2F4F5",
  cascading: "#f6f6f6",
  wildSand: "#F4F4F4",
  brilliance: "#FCFCFD",
  coronation: "#ECECEC",
  hat: "#F3F5F7",
  yukon: "#F7F7F7",
  white: "#FFFFFF",
  blackFire: "#7B5900",
  vermin: "#936F00",
  kenyan: "#B68D00",
  palomino: "#DBAD00",
  fluorescent: "#FFCF00",
  sunny: "#FFDF3F",
  friedEgg: "#FFE866",
  daisy: "#FFF199",
  lemon: "#FFF9CB",
  spruce: "#075F36",
  billiard: "#0D5442",
  jade: "#166649",
  lucky: "#218054",
  eucalyptus: "#329961",
  deepMidori: "#32DA82",
  midori: "#44B26B",
  serengeti: "#70D088",
  pearl: "#91E79E",
  spring: "#BAF7BC",
  transparentGreen: "#DDFADC",
  aero: "#B1E2CC",
  impression: "#111E7A",
  north: "#1E3094",
  night: "#3047B7",
  royal: "#4663DB",
  adamantine: "#48A7F8",
  eye: "#2181D2",
  deep: "#6084FF",
  deepBlue: "#6CBAFC",
  kitten: "#87A5FF",
  cornflower: "#7D64F2",
  indigo: "#937EFF",
  pastel: "#A0B8FF",
  periwinkle: "#BFD1FF",
  sinter: "#DFEAFF",
  anakiwa: "#8BEBFF",
  lavender: "#E5E1FD",
  obscure: "#771B04",
  brownRed: "#912A09",
  martian: "#B4400F",
  tomato: "#D65A14",
  orange: "#FA791D",
  ginger: "#FBA454",
  nouveau: "#FDBF76",
  champagne: "#FED9A4",
  bonnie: "#FDEED1",
  velvet: "#700749",
  orchid: "#870C4D",
  plum: "#A61453",
  rose: "#C91D57",
  pop: "#E92857",
  red: "#FF0000",
  pepper: "#F05B71",
  pepperLight: "#FD7773",
  peach: "#F87C84",
  fond: "#FCADA9",
  pale: "#FCD9D3",
  oregano: "#ED5278",
  amnesia: "rgba(7,7,7,0.05)",
  midnight: "rgba(0,0,0,0.25)",
  paleSky: "#6F767E",
  slate: "#777E91",
  sadet: "#B1B5C3",
  callDark: "#0d0d0d",
  cardDark: "#0f0f10",
  panache: "#ECFCE5",
  pinkTheory: "#FFE5E5",
  ladylike: "#FFC1C1",
  flirtySalmon: "#FF6D6D",
  soulfulBlue: "#777E90",
  greyWhale: "#edeef0",
  pumpkin: "#FA791D",
};

const biggerFontsize = {
  f6: "6px",
  f7: "7px",
  f8: "9px",
  f9: "10px",
  f10: "11px",
  f11: "12px",
  f12: "13px",
  f13: "13px",
  f14: "14px",
  f15: "15px",
  f16: "17px",
  f18: "19px",
  f20: "21px",
  f22: "23px",
  f24: "25px",
};
const regularFontSizes = {
  f6: "6px",
  f7: "7px",
  f8: "8px",
  f9: "9px",
  f10: "10px",
  f11: "11px",
  f12: "12px",
  f13: "13px",
  f14: "14px",
  f15: "15px",
  f16: "16px",
  f18: "18px",
  f20: "20px",
  f22: "22px",
  f24: "24px",
};
export const fontSizes =
  !!window && window?.innerWidth >= 1800 ? biggerFontsize : regularFontSizes;
